// src/components/lessons/renderers/TipsGridRenderer.jsx
import React, { useState } from 'react';
import { Lightbulb } from 'lucide-react';

const TipsGridRenderer = ({ block, isMobile }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '1rem'
      }}>
        {block.tips && block.tips.map((tip, i) => (
          <div
            key={i}
            style={{
              background: hoveredIndex === i ? '#000000' : '#FFFFFF',
              border: '2px solid #000000',
              borderRadius: '0.75rem',
              padding: isMobile ? '1.25rem' : '1.5rem',
              textAlign: 'center',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              cursor: 'default',
              boxShadow: hoveredIndex === i ? '0 8px 24px rgba(0, 0, 0, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
              transform: hoveredIndex === i ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {/* Blue accent line at top */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: '#3A86FF'
            }} />

            {/* Situation header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              marginBottom: '1rem',
              marginTop: '0.5rem'
            }}>
              <div style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                background: hoveredIndex === i ? '#3A86FF' : '#000000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                transform: hoveredIndex === i ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
              }}>
                <Lightbulb style={{
                  width: '14px',
                  height: '14px',
                  color: hoveredIndex === i ? '#000000' : '#3A86FF',
                  transition: 'color 0.3s ease'
                }} />
              </div>
              <p style={{
                fontWeight: '700',
                color: hoveredIndex === i ? '#FFFFFF' : '#000000',
                fontSize: isMobile ? '0.95rem' : '1rem',
                margin: 0,
                transition: 'color 0.3s ease'
             }}>
  {processText(tip.situation)}
</p>
            </div>

            {/* Phrase */}
            <p style={{
              marginTop: '0.75rem',
              fontSize: isMobile ? '0.85rem' : '0.9rem',
              color: hoveredIndex === i ? '#FFFFFF' : '#000000',
              background: hoveredIndex === i ? 'rgba(255, 255, 255, 0.1)' : '#FAFBFC',
              padding: '1rem',
              borderRadius: '0.5rem',
              fontStyle: 'italic',
              lineHeight: '1.6',
              margin: 0,
              border: hoveredIndex === i ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid #E5E7EB',
              transition: 'all 0.3s ease',
              opacity: hoveredIndex === i ? 1 : 0.9
            }}>
  "{processText(tip.phrase)}"
</p>

            {/* Decorative corner dot */}
            {hoveredIndex === i && (
              <div style={{
                position: 'absolute',
                bottom: '12px',
                right: '12px',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: '#3A86FF',
                animation: 'pulse 1.5s ease-in-out infinite'
              }} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TipsGridRenderer;